// extracted by mini-css-extract-plugin
export default {"container":"Wda-z","oos":"Xda-z","oosUx":"Yda-z","selected":"Zda-z","labelOos":"_da-z"};